import React, { Children } from 'react';
import { Layout } from 'antd';


import AppFooter from '../Footer';
import { Outlet } from 'react-router-dom';
import AppHeader from '../Header';
import SiteHeader from '../SiteHeader';
import HeroSection from '../HeroSection';
import ChatbotWidget from '../Widgets/ChatbotWidget';

const { Content } = Layout;

const MainLayout = ({children}) => {
  return (
    <Layout className="layout">
      <SiteHeader />
      <HeroSection/>
      <Content style={{ padding: '50px 50px', minHeight: '85vh' }}>
      <div
            style={{
              padding: 24,
              background: '#f5f5f5',
              minHeight: 360,
            }}
            
          >

{children}
          </div>
      
      </Content>
      <AppFooter />
      <ChatbotWidget />
    </Layout>
  );
};

export default MainLayout;
